module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"nl":{"call-now":"Nu bellen","email":"E-mail"},"nl-BE":{"call-now":"Nu bellen","email":"E-mail"},"es-ES":{"call-now":"Llamar ahora","email":"Correo electrónico"},"de-DE":{"call-now":"Jetzt anrufen","email":"E-Mail"},"fr-BE":{"call-now":"Appeler maintenant","email":"E-mail"},"fr-FR":{"call-now":"Appeler maintenant","email":"E-mail"},"it-IT":{"call-now":"Chiama ora","email":"E-mail"}}')
  delete Component.options._Ctor
}
